// extracted by mini-css-extract-plugin
export default {"button":"yxvyG","inner":"JRBQp","example":"pQfJh","content":"DVuLo","label":"ZPKi9"};